// German dictionary — professionally phrased translations for the interface and
// key homepage content. Missing keys fall back to English (see i18n/index.js).
const de = {
  meta: {
    langName: "Deutsch",
    home_title: "Schönheitschirurgie Vietnam | Unabhängige internationale Patientenbetreuung",
    home_description:
      "Unabhängige internationale Patientenbetreuung für Schönheitschirurgie in Vietnam. Verstehen Sie Ihre Möglichkeiten, vergleichen Sie geeignete Optionen und fordern Sie vor Ihrer Reise eine private, unverbindliche Fallprüfung an.",
  },
  announcement: {
    text: "Unabhängige internationale Patientenbetreuung — keine Klinik und kein Krankenhaus.",
    link: "So funktioniert unsere Fallprüfung",
  },
  nav: {
    procedures: "Eingriffe",
    choosing: "Chirurgen auswählen",
    safety: "Sicherheit",
    costs: "Kosten",
    revision: "Korrektureingriffe",
    results: "Ergebnisse",
    journey: "Patientenreise",
    guides: "Ratgeber",
    about: "Über uns",
    contact: "Kontakt",
    editorial: "Redaktionsrichtlinie",
  },
  cta: {
    caseReview: "Fallprüfung anfordern",
    compare: "Optionen vergleichen",
    explore: "Eingriffe entdecken",
    talk: "Mit unserem Team sprechen",
    guidance: "Behandlungsberatung erhalten",
    sendPhotos: "Fotos zur Prüfung senden",
    exploreOptions: "Optionen entdecken",
    submitReview: "Zur privaten Prüfung senden",
    revisionReview: "Fallprüfung für Korrektur anfordern",
    whatsapp: "WhatsApp",
    menu: "Menü",
    close: "Schließen",
  },
  hero: {
    line1: "Erwägen Sie",
    line2: "Schönheitschirurgie",
    line3: "in Vietnam?",
    subheading:
      "Erhalten Sie unabhängige Unterstützung, vergleichen Sie geeignete Optionen und verstehen Sie Ihren Behandlungsweg, bevor Sie reisen.",
    paragraph:
      "Plastic Surgery Vietnam hilft internationalen Patientinnen und Patienten, erste Fallprüfungen, direkte Beratungen, die Behandlungsplanung und praktische Unterstützung vor, während und nach der Behandlung in Vietnam zu organisieren.",
    trust: [
      "Privat und vertraulich",
      "Keine Verpflichtung",
      "Internationale Patientenbetreuung",
    ],
    scroll: "Weiter scrollen",
  },
  marquee: [
    "Verstehen Sie Ihre Optionen",
    "Unabhängige Beratung",
    "Zugelassene Fachärzte",
    "Realistische Erwartungen",
    "Privat und vertraulich",
    "Internationale Betreuung",
  ],
  form: {
    heading: "Private Fallprüfung anfordern",
    intro:
      "Sagen Sie uns, was Sie erwägen. Unser Team prüft Ihre Anfrage und erklärt Ihnen die passenden nächsten Schritte.",
    fullName: "Vollständiger Name",
    country: "Land",
    email: "E-Mail",
    phone: "Telefon- oder WhatsApp-Nummer",
    preferredContact: "Bevorzugte Kontaktart",
    procedureCategory: "Eingriffskategorie",
    procedureType: "Ist dies ein Ersteingriff oder eine Korrektur?",
    preferredMonth: "Bevorzugter Reisemonat",
    message: "Kurze Nachricht",
    photoUpload: "Optionaler sicherer Foto-Upload",
    photoHint: "JPG, PNG oder WEBP — bis zu 12 MB pro Datei. Fotos werden sicher gespeichert.",
    consent:
      "Ich stimme zu, dass Plastic Surgery Vietnam mich bezüglich meiner Anfrage kontaktiert, und ich habe die Datenschutz- und medizinischen Hinweise gelesen.",
    contactOptions: { email: "E-Mail", phone: "Telefon", whatsapp: "WhatsApp" },
    categoryOptions: {
      unsure: "Ich bin mir nicht sicher",
      face: "Gesicht",
      nose: "Nase",
      breast: "Brust",
      body: "Körper",
      revision: "Korrektureingriff",
      other: "Sonstiges",
    },
    typeOptions: {
      firstTime: "Ersteingriff",
      previousNoProblem: "Früherer Eingriff ohne aktuelles Problem",
      revision: "Korrektur oder Nachbesserung",
      complication: "Komplikation oder dringendes Anliegen",
    },
    placeholders: {
      select: "Bitte auswählen",
      message: "Beschreiben Sie kurz, was Sie erwägen...",
      month: "z. B. März 2026",
    },
    success: {
      heading: "Vielen Dank — Ihre Anfrage ist eingegangen",
      points: [
        "Ihre Anfrage ist bei unserem Patientenbetreuungsteam eingegangen.",
        "Fotografien ersetzen keine persönliche Untersuchung.",
        "Eine endgültige Behandlungsempfehlung kommt von zugelassenen Fachärzten.",
        "Wir kontaktieren Sie über die von Ihnen gewählte Kontaktart.",
      ],
      again: "Weitere Anfrage senden",
    },
    errors: {
      required: "Dieses Feld ist erforderlich",
      email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      consent: "Bitte erteilen Sie Ihre Zustimmung, um fortzufahren",
      submit: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    },
    disclaimer:
      "Fotografien dienen nur einer ersten Prüfung. Eine endgültige Empfehlung kommt stets von zugelassenen Fachärzten nach einer persönlichen Untersuchung.",
  },
  footer: {
    description:
      "Eine unabhängige internationale Informations- und Koordinationsplattform für Menschen, die eine plastische, ästhetische, rekonstruktive oder korrigierende Operation in Vietnam erwägen.",
    procedures: "Eingriffe",
    guides: "Patientenratgeber",
    contact: "Kontakt",
    languages: "Sprache",
    legal: "Rechtliches",
    rights: "Alle Rechte vorbehalten.",
  },
  common: {
    learnMore: "Mehr erfahren",
    readGuide: "Ratgeber lesen",
    backHome: "Zurück zur Startseite",
    breadcrumbHome: "Startseite",
    translationNotice:
      "Die vollständigen deutschen Inhalte werden derzeit von unserem Team vorbereitet. Oberfläche und wichtige Informationen sind in Ihrer Sprache verfügbar; einige ausführliche Artikel werden vorübergehend auf Englisch angezeigt, während die professionellen Übersetzungen finalisiert werden.",
  },
};

export default de;
